<template>
  <BaseSelect
    :id="id"
    :value="value"
    :options="[
      { value: 'F', text: 'Factura' },
      { value: 'R', text: 'Abono' },
      { value: 'B', text: 'Borrador' },
      { value: 'BR', text: 'Borrador Abono' }
    ]"
    label="text"
    :reduce="option => option.value"
    @input="$emit('input', $event)"
  />
</template>

<script>
import BaseSelect from '@/components/ui/select/BaseSelect.vue'

export default {
  name: 'SaleInvoicesCategorySelect',
  components: { BaseSelect },
  props: {
    value: {
      type: [Object, String, Number],
      default: null,
    },
    id: {
      type: String,
      default: null,
    },
  },
}
</script>

<style scoped>
</style>
